import {Col, List, Row, Switch} from "antd";
import {CheckOutlined} from "@ant-design/icons";
import React from "react";
import styled from "styled-components";
import {mapLastPeriod, mapPeriod} from "../common/mapPeriod";
import {dataDate} from "../defaultValue/dataDate";

const StyledList = styled(List)`
  .ant-spin-container {
    height: ${(props) => props?.height + "px"};
    overflow-y: auto;
  }

  .ant-list-item {
    display: list-item !important;
    padding-right: 12px !important;
  }
`;
const RenderKeyCompare = ({compare,setCompare, setCompareType, compareType, type, selectedDateRange}) => {

    return (
        <div className={"p-6"}>
            <Row>
                <Col span={20}>
                    So sánh
                </Col>
                <Col span={4}>
                    <Switch checked={compare} onChange={(checked) => setCompare(checked)}/>
                </Col>
            </Row>

            <StyledList
                header={null}
                footer={null}
                bordered={false}
                dataSource={dataDate()}
                renderItem={(item) => (
                    <List.Item>
                        <Row className={"items-center"}>
                            <Col span={23}>
                                <div className={"flex flex-col"} onClick={() => {
                                    setCompareType(item.key)
                                }}>
                                        <span style={{
                                            color: compareType === item.key ? "#007FFF" : ""
                                        }}>
                                            {item.title}
                                        </span>
                                    <span>{
                                        item.key === "previousPeriod" ?
                                            mapPeriod( type, selectedDateRange.startDate, selectedDateRange.endDate ) :
                                            mapLastPeriod( type, selectedDateRange.startDate, selectedDateRange.endDate )
                                    }</span>
                                </div>
                            </Col>
                            <Col span={1}>
                                {
                                    compareType === item.key &&
                                    <CheckOutlined style={{color: "#007FFF"}}/>
                                }
                            </Col>
                        </Row>
                    </List.Item>
                )}
            />
        </div>
    )
}

export default RenderKeyCompare
